import React from 'react';

interface IconButtonProps {
  icon: string;
  text: string;
  block?: boolean;
  background?: string;
  textColor?: string;
  direction?: 'ltr' | 'rtl';
  onClick?: () => void;
}

class IconButton extends React.Component<IconButtonProps> {

  static defaultProps = {
    textColor: '#fff',
    background: '#2F9AF1',
    direction: 'ltr'
  }

  render() {
    const { icon, text, textColor: color, background, direction, block } = this.props;
    const isRtl = this.props.direction === 'rtl';
    const margin = isRtl ? { marginLeft: '5px' } : { marginRight: '5px' };
    let classes = 'btn btn-app icon-button-component' + (block ? ' btn-block' : '');
    return (
      <button
        onClick={this.props.onClick}
        style={{ background, direction }}
        className={classes}>
        <i className={icon} style={{ ...margin }}></i>
        <span style={{ color }}>{text}</span>
      </button>
    );
  }
}

export default IconButton;
